var _style, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-edit_svg__Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon-edit_svg__st0{fill:#050505}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-edit_svg__st0",
    d: "M19.8 3.2c-.1-.7-.5-1.3-1.1-1.6L17.4.8c-.6-.3-1.3-.4-1.9-.1-.7.3-1.2.7-1.5 1.3l-1.6 2.7L7 14c-.7 1.2-1.1 2.4-1.1 3.4-.1 1.3.3 2.3 1.2 2.8.3.2.7.3 1.1.3 1.4 0 3.1-1.3 4.3-3.4l5.4-9.3 1.6-2.7c.3-.6.4-1.2.3-1.9zm-9.1 13c-1.1 1.9-2.4 2.5-2.7 2.4-.1 0-.2-.3-.2-.9.1-.8.4-1.7.9-2.6l4.9-8.5 2 1.1-4.9 8.5zm7-12.1L16.6 6l-2-1.1L15.7 3c.1-.2.3-.3.4-.4h.2l1.3.8c.1 0 .1.2.1.2.1.1.1.3 0 .5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-edit_svg__st0",
    d: "M17.7 23.4H5.2c-.6 0-1-.4-1-1s.4-1 1-1h12.5c.6 0 1 .4 1 1s-.4 1-1 1z",
    opacity: 0.33
  })));
}

export default SvgIconEdit;